// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportConfigurationHeader.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ReportConfigurationHeader component
 */
!(function () {
  "use strict";

  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  
  var Button = require('share/components/controls/Izenda.Button');
  var Alert = require('share/components/controls/Izenda.Alert');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');

  var actions = require('./Izenda.ReportConfigurationAction');

  var ReportConfigurationHeader = function (props) {
    var localization = props.localization;
    var alertDetail = props.store.alertDetail;
    return (
      <GridLayout className='u_paddingBottom'>
        <GridLayout.Row>
          <GridLayout.Col cols='7'>
            <Alert className='u_floatLeft u_marginLeft' type={alertDetail.alertType}>{alertDetail.message}</Alert>
          </GridLayout.Col>
          <GridLayout.Col className='u_noPaddingRight' cols='5'>
            <Button label={localization.getText('COMMON_LABEL_CANCEL')} className='u_marginLeftRight u_floatRight btn-report-default' onClick={props.onCancel}></Button>
            <Button label={localization.getText('COMMON_LABEL_SAVE')} className='u_marginLeft u_floatRight' onClick={props.onSave}></Button>
          </GridLayout.Col>
        </GridLayout.Row>
      </GridLayout>
    );
  };

  module.exports = connect(actions)(ReportConfigurationHeader);
}());



// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/Report/Izenda.ReportConfigurationHeader.jsx